
import React from "react";

const StaticTextLoading: React.FC = () => {
  return (
    <div className="flex justify-center items-center p-12">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-toctoc-blue"></div>
      <span className="ml-3">Carregando textos fixos...</span>
    </div>
  );
};

export default StaticTextLoading;
